import React from 'react';
import {Typography} from '@material-ui/core';
import Button from '@material-ui/core/Button/Button';
import {Content as ContentIcon} from '../theme/MenuIcons'


const EmptyStateMessage = ({
  title,
  callToAction,
  onClick,
} : {
  title: string,
  callToAction: string,
  onClick: (event: React.MouseEvent) => void
}) =>
  <div style={{
    marginTop: 82,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center'
  }}>
    <Typography variant='h5' component='span'>
      {title}
    </Typography>
    <Button
      color='primary'
      size='large'
      onClick={onClick}
    >
      {callToAction}
    </Button>
  </div>;

export default EmptyStateMessage;
